import React from 'react'
import THCSeltzerRedTemplate from './template_updates/THCSeltzerRedTemplate'
import THCRedTemplate from './template_updates/THCRedTemplate'
import SeltzerRedTemplate from './template_updates/SeltzerRedTemplate'

class THCSeltzerRed extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            seltzerMenu: '',
            thcMenu: '',
            redWine: ''
        }
    }
    getRedWine = (menuId) => {
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${menuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data)
            let redWine = data.menu.sections.filter(section => section.name === "Red Wine")
            return redWine[0]
        })
        .then(redWine => this.setState({redWine: redWine}))
        .catch(err => err)
    }
    getSeltzers = (menuId) => {
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${menuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data.menu)
            let thcSeltzer = data.menu.sections[1]
            let alcoholicSeltzer = data.menu.sections[0]

            this.setState({seltzerMenu: alcoholicSeltzer, thcMenu: thcSeltzer })
        })
    }
    componentDidMount(){
        const seltzerMenuId = this.props.match.params.seltzerId
        const wineMenuId = this.props.match.params.wineId

        this.getRedWine(wineMenuId)
        this.getSeltzers(seltzerMenuId)
    }
    chooseLayout(){
        if (this.props.match.params.location === "pl2" || this.props.match.params.location === "pl5"){
            return (
                <THCRedTemplate 
                    thcMenu={this.state.thcMenu}
                    redWine={this.state.redWine}
                />
            )
        } else if (this.props.match.params.location === "pl7"){
            return (
                <SeltzerRedTemplate 
                    seltzerMenu={this.state.seltzerMenu}
                    redWine={this.state.redWine}
                />
            )
        } else {
            return (
                <THCSeltzerRedTemplate 
                    seltzerMenu={this.state.seltzerMenu}
                    thcMenu={this.state.thcMenu}
                    redWine={this.state.redWine}
            />
            )
        }
    }
    render(){
        console.log(this.props)
        console.log(this.state)
        return this.chooseLayout()
    }
}
export default THCSeltzerRed 